import TemplatedButton from './templated-button';

export default TemplatedButton;
